





















































import {Vue, Component, Prop, Mixins} from "vue-property-decorator";
import ImageUploader from "@/components/ui/ImageUploader.vue";
import { UserFileService, UserFile, UserFileRequest} from "../services/userFile.service";
import NotificationMixin from "../mixins/NotificationMixin";
import CardCollapsible from "@/components/ui/CardCollapsible.vue";

@Component({
    components: {
        ImageUploader,
        CardCollapsible,
    }
})
export default class UserFileManager extends Mixins(NotificationMixin) {
    private service!: UserFileService;

    private list: UserFile[] = [];

    private editing: UserFileRequest | null = null;
    private editingId: string | null = null;
    private editingError: string | null = null;
    private editingPreview: string | null = null;

    private async getList() {
        const res = await this.service.get();
        if (res.success) {
            this.list = res.result;
        }
    }

    private edit(item: UserFile) {
        this.editing = {
            name: item.name,
            alt: item.alt,
            file: null,
        }
        this.editingId = item.id;
    }

    private saved() {
        this.notifySuccess("File added");
        this.getList();
    }

    private async fileUpload(e: any) {
        if (this.editing) {
            this.editingError = null;
            if (e.target.files.length === 0) {
                this.editing.file = null;
            }

            this.editing.file = e.target.files[0];
            this.editingPreview = URL.createObjectURL(this.editing.file);
            this.editing.name = this.editing.file.name;
        }
    }

    private copyToClipboard(text: string) {
        navigator.clipboard.writeText(text).then(() => {
            this.notifySuccess("Copied to clipboard");
        }).catch(() => {
            this.notifyError("Failed to copy");
        })
    }

    private async deleteFile(id: string) {
        const res = await this.service.delete(id);
        if (res.success) {
            this.getList();
            this.notifySuccess("File deleted");
        } else {
            this.notifyError("Failed to delete file: " + res.error);
        }
    }

    private async update() {
        if (this.editing && this.editingId) {
            const data = new FormData();
            data.append('name', this.editing.name);
            data.append('alt', this.editing.alt);
            data.append('file', this.editing.file);
            const res = await this.service.putFormData(this.editingId, data);
            if (res.success) {
                this.editing = null;
                this.editingId = null;
                this.notifySuccess('File updated');
                this.getList();
            } else {
                this.notifyError('Failed to update: ' + res.error);
            }
        }
    }

    private created() {
        this.service = new UserFileService();
        this.getList();
    }
}
